import React from 'react';
import BriefWizard from '@99designs/apps/spa/pages/create/briefs/BriefWizard';
import { StructuredBriefFragment } from '@99designs/apps/spa/pages/create/briefs/DynamicBrief/DynamicBrief.generated';
import { StepType } from '@99designs/apps/spa/pages/create/util/step';
import InviteDesignersPage from '@99designs/apps/spa/pages/create/components/InviteDesignersPage';
import { createSteps } from './Step';
import { Summary } from './Summary';

export function RequestQuoteBriefWizard({
    brief,
    formData,
    refetch,
    currentStep,
}: {
    brief: StructuredBriefFragment;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: Record<string, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    refetch: (options: { id: string }) => Promise<any>;
    currentStep: number;
}) {
    return (
        <BriefWizard
            refetch={refetch}
            brief={brief}
            formData={formData}
            schema={brief.schemaId}
            disableContacts
            currentStep={currentStep}
            steps={createSteps(brief, [
                {
                    title: __('Review your brief'),
                    render: () => <Summary brief={brief} />,
                },
                {
                    title: __('Invite designers to quote'),
                    isAuthRequired: true,
                    stepType: StepType.Designer,
                    render: () => <InviteDesignersPage brief={brief} />,
                    nextActionLabel: __('Confirm designers'),
                },
            ])}
        />
    );
}
